import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import GlobalDiamondReportService from "../../services/reports-globalDiamond-service";
import ReportScaffold from "./DiamondReportsCharts/_shared/ReportScaffold";
import DetailSearchTable from "./DiamondReportsCharts/_shared/DetailSearchTable";
import { SIZE_CONFIG } from "./DiamondReportsCharts/_shared/reportConfigs";
import { exportChartPdf } from "./DiamondReportsCharts/_shared/exportChartPdf";

const DiamondSizeIndComp = () => {
  const loginDetials = useSelector((state) => state.loginReducer);

  const initialGlobalDiamondState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedDiamondValue: "All",
    retailerIds: [],
    vendorIds: [],
  };

  const [globalDiamonds, setGlobalDiamond] = useState(initialGlobalDiamondState);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const [refetchToken, setRefetchToken] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleCheckDealermembers(loginDetials.loginDetials.responseData.dealerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckDealermembers = (id) => {
    GlobalDiamondReportService.CheckDealermembers({ dealerID: id })
      .then((response) => {
        if (response.data.message === "Success") {
          const responseData = response.data.responseData;
          const fd = Object.keys(responseData).length !== 0 ? responseData.forDealer : "";
          setForDealer(fd || "");
          handleLoadReport(id, fd);
        } else {
          setForDealer("");
        }
      })
      .catch(() => setForDealer(""));
  };

  const handleLoadReport = (dealerIdArg, forDealerArg) => {
    let inputData = {
      dealerID: dealerIdArg.toString(),
      forDealer: forDealerArg ? forDealerArg.toString() : "",
      fromDate: globalDiamonds.dataRangeFrom
        ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalDiamonds.dataRangeTo
        ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalDiamonds.retailerIds.toString(),
      vendorIds: globalDiamonds.vendorIds.toString(),
      selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      type: "",
      reportName: "ExtDiamondChrt",
    };

    setLoading(true);
    GlobalDiamondReportService.LoadChartReports(inputData)
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Success" && response.data.responseData) {
          setReport(response.data.responseData);
        } else {
          setReport(null);
        }
      })
      .catch(() => {
        setLoading(false);
        setReport(null);
      });
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalDiamond((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const onDiamondTypeChange = (e, name) => {
    setGlobalDiamond({ ...globalDiamonds, [name]: e });
  };

  const handleApplyFilter = () => {
    setFilterValue("");
    handleLoadReport(dealerId, forDealer);
    setRefetchToken((tok) => tok + 1);
  };

  const handleSliceClick = (value) => {
    setFilterValue(value);
  };

  const handleDownloadChart = async () => {
    setPdfLoading(true);
    try {
      await exportChartPdf({
        elementId: "pdf-content",
        title: SIZE_CONFIG.pageTitle,
        dealerCompany: loginDetials?.loginDetials?.responseData?.dealerCompany,
        dealerId,
        dataRangeFrom: globalDiamonds.dataRangeFrom,
        dataRangeTo: globalDiamonds.dataRangeTo,
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
        totalClicks: report?.TotalDiamondClicks?.[0]?.TotalClickCnt,
        fileName: "Diamond-Size-Search-Report.pdf",
      });
    } finally {
      setPdfLoading(false);
    }
  };

  return (
    <ReportScaffold
      config={SIZE_CONFIG}
      report={report}
      loading={loading}
      dealerId={dealerId}
      forDealer={forDealer}
      dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
      globalDiamonds={globalDiamonds}
      onDateChange={onDateChange}
      onDiamondTypeChange={onDiamondTypeChange}
      onApplyFilter={handleApplyFilter}
      refetchToken={refetchToken}
      onDownloadChart={handleDownloadChart}
      downloadingChart={pdfLoading}
      onChartClick={handleSliceClick}
      detailTable={
        <DetailSearchTable
          dealerId={dealerId}
          forDealer={forDealer}
          dataRangeFrom={globalDiamonds.dataRangeFrom}
          dataRangeTo={globalDiamonds.dataRangeTo}
          selectedDiamondValue={globalDiamonds.SelectedDiamondValue}
          reportName={SIZE_CONFIG.detail.reportName}
          filterParamName={SIZE_CONFIG.detail.filterParamName}
          filterValue={filterValue}
          fileNamePart={SIZE_CONFIG.detail.fileNamePart}
          dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
          refetchToken={refetchToken}
          reporttype="Global"
        />
      }
    />
  );
};

export default DiamondSizeIndComp;
